import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7008912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-style-panel" }
const _hoisted_2 = { class: "row tr_row" }
const _hoisted_3 = { style: {"flex":"2"} }
const _hoisted_4 = {
  class: "set-count",
  style: {"flex":"3"}
}
const _hoisted_5 = { class: "count-text" }
const _hoisted_6 = { class: "row tr_row" }
const _hoisted_7 = { style: {"flex":"2"} }
const _hoisted_8 = {
  class: "set-count",
  style: {"flex":"3"}
}
const _hoisted_9 = { class: "count-text" }
const _hoisted_10 = { class: "row theme-switch tr_row" }
const _hoisted_11 = { style: {"flex":"2"} }
const _hoisted_12 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_13 = { class: "row tr_row" }
const _hoisted_14 = { class: "row tr_row" }
const _hoisted_15 = { class: "row tr_row" }
const _hoisted_16 = { style: {"flex":"2"} }

import { computed, onMounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { nanoid } from "nanoid";
import { useMainStore, useSlidesStore } from "@/store";
import {
  PPTTableElement,
  TableCell,
  TableCellStyle,
  TableTheme,
} from "@/types/slides";
import { WEB_FONTS } from "@/configs/font";
import useHistorySnapshot from "@/hooks/useHistorySnapshot";
import { useI18n } from "vue-i18n";
import ElementOutline from "../common/ElementOutline.vue";
import ColorButton from "../common/ColorButton.vue";
import TextColorButton from "../common/TextColorButton.vue";
import CheckboxButton from "@/components/CheckboxButton.vue";
import CheckboxButtonGroup from "@/components/CheckboxButtonGroup.vue";
import ColorPicker from "@/components/ColorPicker/index.vue";
import {
  Divider,
  Button,
  Tooltip,
  Popover,
  Select,
  Switch,
  Checkbox,
  Radio,
  Input,
} from "ant-design-vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'TableStylePanel',
  setup(__props) {

const { t, locale } = useI18n();

const { Group: RadioGroup, Button: RadioButton } = Radio;
const { OptGroup: SelectOptGroup, Option: SelectOption } = Select;
const InputGroup = Input.Group;
const ButtonGroup = Button.Group;

const slidesStore = useSlidesStore();
const {
  handleElement,
  handleElementId,
  selectedTableCells: selectedCells,
  availableFonts,
} = storeToRefs(useMainStore());
const themeColor = computed(() => slidesStore.theme.themeColor);

const fontSizeOptions = [
  "12px",
  "14px",
  "16px",
  "18px",
  "20px",
  "22px",
  "24px",
  "28px",
  "32px",
];

const textAttrs = ref({
  bold: false,
  em: false,
  underline: false,
  strikethrough: false,
  color: "#000",
  backcolor: "",
  fontsize: "12px",
  fontname: "Arial",
  align: "left",
});

const theme = ref<TableTheme>();
const hasTheme = ref(false);
const rowCount = ref(0);
const colCount = ref(0);
const minRowCount = ref(0);
const minColCount = ref(0);

watch(
  handleElement,
  () => {
    if (!handleElement.value || handleElement.value.type !== "table") return;

    theme.value = handleElement.value.theme;
    hasTheme.value = !!theme.value;

    rowCount.value = handleElement.value.data.length;
    colCount.value = handleElement.value.data[0].length;

    minRowCount.value = handleElement.value.data.length;
    minColCount.value = handleElement.value.data[0].length;
  },
  { deep: true, immediate: true }
);

const { addHistorySnapshot } = useHistorySnapshot();

// 更新当前选中单元格的文本样式状态
const updateTextAttrState = () => {
  if (!handleElement.value || handleElement.value.type !== "table") return;

  let rowIndex = 0;
  let colIndex = 0;
  if (selectedCells.value.length) {
    const selectedCell = selectedCells.value[0];
    rowIndex = +selectedCell.split("_")[0];
    colIndex = +selectedCell.split("_")[1];
  }
  const style = handleElement.value.data[rowIndex][colIndex].style;

  if (!style) {
    textAttrs.value = {
      bold: false,
      em: false,
      underline: false,
      strikethrough: false,
      color: "#000",
      backcolor: "",
      fontsize: "12px",
      fontname: "Arial",
      align: "left",
    };
  } else {
    textAttrs.value = {
      bold: !!style.bold,
      em: !!style.em,
      underline: !!style.underline,
      strikethrough: !!style.strikethrough,
      color: style.color || "#000",
      backcolor: style.backcolor || "",
      fontsize: style.fontsize || "12px",
      fontname: style.fontname || "Arial",
      align: style.align || "left",
    };
  }
};

onMounted(() => {
  if (selectedCells.value.length) updateTextAttrState();
});

watch(selectedCells, updateTextAttrState);

const updateElement = (props: Partial<PPTTableElement>) => {
  slidesStore.updateElement({ id: handleElementId.value, props });
  addHistorySnapshot();
};

// 设置单元格内容文本样式
const updateTextAttrs = (textAttrProp: Partial<TableCellStyle>) => {
  const _handleElement = handleElement.value as PPTTableElement;

  const data: TableCell[][] = JSON.parse(JSON.stringify(_handleElement.data));

  for (let i = 0; i < data.length; i++) {
    for (let j = 0; j < data[i].length; j++) {
      if (
        !selectedCells.value.length ||
        selectedCells.value.includes(`${i}_${j}`)
      ) {
        const style = data[i][j].style || {};
        data[i][j].style = { ...style, ...textAttrProp };
      }
    }
  }
  updateElement({ data });
  updateTextAttrState();
};

// 更新表格主题：主题色、标题行、汇总行、第一列、最后一列
const updateTheme = (themeProp: Partial<TableTheme>) => {
  if (!theme.value) return;
  const _theme = { ...theme.value, ...themeProp };
  updateElement({ theme: _theme });
};

// 开启/关闭表格主题
const toggleTheme = (checked: boolean) => {
  if (checked) {
    const props = {
      theme: {
        color: themeColor.value,
        rowHeader: true,
        rowFooter: false,
        colHeader: false,
        colFooter: false,
      },
    };
    updateElement(props);
  } else {
    slidesStore.removeElementProps({
      id: handleElementId.value,
      propName: "theme",
    });
    addHistorySnapshot();
  }
};

// 设置表格行数
const setTableRow = (value: number) => {
  const _handleElement = handleElement.value as PPTTableElement;
  const rowCount = _handleElement.data.length;

  if (value > rowCount) {
    const rowCells: TableCell[] = new Array(colCount.value).fill({
      id: nanoid(10),
      colspan: 1,
      rowspan: 1,
      text: "",
    });
    const newTableCells: TableCell[][] = new Array(value - rowCount).fill(
      rowCells
    );

    const tableCells: TableCell[][] = JSON.parse(
      JSON.stringify(_handleElement.data)
    );
    tableCells.push(...newTableCells);

    updateElement({ data: tableCells });
  } else {
    const tableCells: TableCell[][] = _handleElement.data.slice(0, value);
    updateElement({ data: tableCells });
  }
};

// 设置表格列数
const setTableCol = (value: number) => {
  const _handleElement = handleElement.value as PPTTableElement;
  const colCount = _handleElement.data[0].length;

  let tableCells = _handleElement.data;
  let colSizeList = _handleElement.colWidths.map(
    (item) => item * _handleElement.width
  );

  if (value > colCount) {
    tableCells = tableCells.map((item) => {
      const cells: TableCell[] = new Array(value - colCount).fill({
        id: nanoid(10),
        colspan: 1,
        rowspan: 1,
        text: "",
      });
      item.push(...cells);
      return item;
    });

    const newColSizeList: number[] = new Array(value - colCount).fill(100);
    colSizeList.push(...newColSizeList);
  } else {
    tableCells = tableCells.map((item) => item.slice(0, value));
    colSizeList = colSizeList.slice(0, value);
  }

  const width = colSizeList.reduce((a, b) => a + b);
  const colWidths = colSizeList.map((item) => item / width);

  const props = {
    width,
    data: tableCells,
    colWidths,
  };
  updateElement(props);
};

return (_ctx: any,_cache: any) => {
  const _component_IconFontSize = _resolveComponent("IconFontSize")!
  const _component_IconAddText = _resolveComponent("IconAddText")!
  const _component_IconText = _resolveComponent("IconText")!
  const _component_IconFill = _resolveComponent("IconFill")!
  const _component_IconTextBold = _resolveComponent("IconTextBold")!
  const _component_IconTextItalic = _resolveComponent("IconTextItalic")!
  const _component_IconTextUnderline = _resolveComponent("IconTextUnderline")!
  const _component_IconStrikethrough = _resolveComponent("IconStrikethrough")!
  const _component_IconAlignTextLeft = _resolveComponent("IconAlignTextLeft")!
  const _component_IconAlignTextCenter = _resolveComponent("IconAlignTextCenter")!
  const _component_IconAlignTextRight = _resolveComponent("IconAlignTextRight")!
  const _component_IconMinus = _resolveComponent("IconMinus")!
  const _component_IconPlus = _resolveComponent("IconPlus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputGroup), {
      compact: "",
      class: "row tr_row"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          style: {"flex":"3"},
          value: textAttrs.value.fontname,
          onChange: _cache[0] || (_cache[0] = value => updateTextAttrs({ fontname: value as string }))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_IconFontSize)
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(SelectOptGroup), {
              label: _unref(t)(`public.font.sysFont`)
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableFonts), (font) => {
                  return (_openBlock(), _createBlock(_unref(SelectOption), {
                    key: font.value,
                    value: font.value
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        style: _normalizeStyle({ fontFamily: font.value })
                      }, _toDisplayString(font.label), 5)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["value"]),
        _createVNode(_unref(Select), {
          style: {"flex":"2"},
          value: textAttrs.value.fontsize,
          onChange: _cache[1] || (_cache[1] = value => updateTextAttrs({ fontsize: value as string }))
        }, {
          suffixIcon: _withCtx(() => [
            _createVNode(_component_IconAddText)
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(fontSizeOptions, (fontsize) => {
              return _createVNode(_unref(SelectOption), {
                key: fontsize,
                value: fontsize
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(fontsize), 1)
                ]),
                _: 2
              }, 1032, ["value"])
            }), 64))
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      _: 1
    }),
    _createVNode(_unref(ButtonGroup), { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Popover), { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: textAttrs.value.color,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = (value) => updateTextAttrs({ color: value }))
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Tooltip), {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: _unref(t)(`public.font.fontColor`)
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: textAttrs.value.color,
                  style: {"flex":"1"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconText)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay", "title"])
          ]),
          _: 1
        }),
        _createVNode(_unref(Popover), { trigger: "click" }, {
          content: _withCtx(() => [
            _createVNode(ColorPicker, {
              modelValue: textAttrs.value.backcolor,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = 
              (value) => updateTextAttrs({ backcolor: value })
            )
            }, null, 8, ["modelValue"])
          ]),
          default: _withCtx(() => [
            _createVNode(_unref(Tooltip), {
              mouseLeaveDelay: 0,
              mouseEnterDelay: 0.5,
              title: _unref(t)(`editor.toolbar.elementStylePanel.tableStylePanel.colFull`)
            }, {
              default: _withCtx(() => [
                _createVNode(TextColorButton, {
                  color: textAttrs.value.backcolor,
                  style: {"flex":"1"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconFill)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            }, 8, ["mouseEnterDelay", "title"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(CheckboxButtonGroup, { class: "row tr_row" }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.bold`)
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: textAttrs.value.bold,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (updateTextAttrs({ bold: !textAttrs.value.bold })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTextBold)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.em`)
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: textAttrs.value.em,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (updateTextAttrs({ em: !textAttrs.value.em })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTextItalic)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.underline`)
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: textAttrs.value.underline,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (updateTextAttrs({ underline: !textAttrs.value.underline })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconTextUnderline)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.strikethrough`)
        }, {
          default: _withCtx(() => [
            _createVNode(CheckboxButton, {
              style: {"flex":"1"},
              checked: textAttrs.value.strikethrough,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (updateTextAttrs({ strikethrough: !textAttrs.value.strikethrough })))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconStrikethrough)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"])
      ]),
      _: 1
    }),
    _createVNode(_unref(RadioGroup), {
      class: "row tr_row",
      "button-style": "solid",
      value: textAttrs.value.align,
      onChange: _cache[8] || (_cache[8] = (e) => updateTextAttrs({ align: e.target.value }))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.left`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RadioButton), {
              value: "left",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextLeft)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.middle`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RadioButton), {
              value: "center",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextCenter)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"]),
        _createVNode(_unref(Tooltip), {
          mouseLeaveDelay: 0,
          mouseEnterDelay: 0.5,
          title: _unref(t)(`public.font.right`)
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(RadioButton), {
              value: "right",
              style: {"flex":"1"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconAlignTextRight)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["mouseEnterDelay", "title"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_unref(Divider)),
    _createVNode(ElementOutline, { fixed: true }),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.row`)) + "： ", 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Button), {
          class: "btn",
          disabled: rowCount.value <= 1,
          onClick: _cache[9] || (_cache[9] = ($event: any) => (setTableRow(rowCount.value - 1)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconMinus)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(rowCount.value), 1),
        _createVNode(_unref(Button), {
          class: "btn",
          disabled: rowCount.value >= 30,
          onClick: _cache[10] || (_cache[10] = ($event: any) => (setTableRow(rowCount.value + 1)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconPlus)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.col`)) + "： ", 1),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Button), {
          class: "btn",
          disabled: colCount.value <= 1,
          onClick: _cache[11] || (_cache[11] = ($event: any) => (setTableCol(colCount.value - 1)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconMinus)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(colCount.value), 1),
        _createVNode(_unref(Button), {
          class: "btn",
          disabled: colCount.value >= 30,
          onClick: _cache[12] || (_cache[12] = ($event: any) => (setTableCol(colCount.value + 1)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_IconPlus)
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ]),
    _createVNode(_unref(Divider)),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.themeTable`)) + "： ", 1),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_unref(Switch), {
          checked: hasTheme.value,
          onChange: _cache[13] || (_cache[13] = checked => toggleTheme(checked as boolean))
        }, null, 8, ["checked"])
      ])
    ]),
    (theme.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_unref(Checkbox), {
              onChange: _cache[14] || (_cache[14] = (e) => updateTheme({ rowHeader: e.target.checked })),
              checked: theme.value.rowHeader,
              style: {"flex":"1","color":"#333"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.titleRow`)), 1)
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(Checkbox), {
              onChange: _cache[15] || (_cache[15] = (e) => updateTheme({ rowFooter: e.target.checked })),
              checked: theme.value.rowFooter,
              style: {"flex":"1","color":"#333"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.totalRow`)), 1)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Checkbox), {
              onChange: _cache[16] || (_cache[16] = (e) => updateTheme({ colHeader: e.target.checked })),
              checked: theme.value.colHeader,
              style: {"flex":"1","color":"#333"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.firstCol`)), 1)
              ]),
              _: 1
            }, 8, ["checked"]),
            _createVNode(_unref(Checkbox), {
              onChange: _cache[17] || (_cache[17] = (e) => updateTheme({ colFooter: e.target.checked })),
              checked: theme.value.colFooter,
              style: {"flex":"1","color":"#333"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.lastCol`)), 1)
              ]),
              _: 1
            }, 8, ["checked"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t(`editor.toolbar.elementStylePanel.tableStylePanel.titleColor`)) + "： ", 1),
            _createVNode(_unref(Popover), { trigger: "click" }, {
              content: _withCtx(() => [
                _createVNode(ColorPicker, {
                  modelValue: theme.value.color,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = (value) => updateTheme({ color: value }))
                }, null, 8, ["modelValue"])
              ]),
              default: _withCtx(() => [
                _createVNode(ColorButton, {
                  color: theme.value.color,
                  style: {"flex":"3"}
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})